module.exports = __webpack_public_path__ + "img/ic_search.4e7f8bee.svg";